import type {SxProps} from '@mui/material';
import {Stack} from '@mui/material';
import type * as React from 'react';

type Props = {
    children: React.ReactElement | React.ReactElement[];
    sx?: SxProps;
};

const StackRow = ({children, sx}: Props): React.ReactElement => {
    return (
        <Stack
            sx={{
                flexDirection: 'row',
                ...sx,
            }}
        >
            {children}
        </Stack>
    );
};

export default StackRow;
